import './Commons.css';
import { styled } from '@mui/material/styles';
import { Box, Button, Container, Grid, List, MenuList } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import logo from '../../assets/landing/Logo.svg';
import logoAzul from '../../assets/landing/LogoAZUL.svg';
import PhoneIcon from '@mui/icons-material/Phone';
import Link from '@mui/material/Link';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import FormDialog from '../Commons/FormDialog';
import AyudaModal from '../Inicio/AyudaModal';
import { useLocation } from 'react-router-dom';


export default function Header(props) {
  const location = useLocation();
  const [openFormModal, setOpenFormModal] = React.useState(false);
  const [isInicio, setIsInicio] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const ColorButton = styled(Button)(({ theme }) => ({
    color: (props.isFromInicio ? '#039ECC' : '#FFFFFF'),
    backgroundColor: (props.isFromInicio ? '#FFFFFF' : '#039ECC'),
    '&:hover': {
      backgroundColor: (props.isFromInicio ? '#FFFFFF' : '#039ECC'),
    },
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
  }));
  const open = Boolean(anchorEl);
  const handleMovil = (event) => {
    setAnchorEl(event.currentTarget)
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenSeguros = e => {
    setAnchorEl2(e.currentTarget)
  };
  const handleCloseSeguros = () => {
    setAnchorEl2(null);
  }

  const [openL, setOpenL] = React.useState(false);

  const handleClick = () => {
    setOpenL(!openL);
  };
  const handleClickClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpenFormModal(false);
    }
  };

  const ModalAyuda = () => {
    return <AyudaModal handleClose={handleClickClose} />;
  };

  const handleClickModal = () => {
    handleClickOpen();
  }

  const handleClickOpen = () => {
    setOpenFormModal(true);
  };

  useEffect(() => {
    if (location.pathname === '/inicio') {
      setIsInicio(true);
    } else {
      setIsInicio(false);
    }
  }, [location.pathname]);

  return (
    <>
      <FormDialog open={openFormModal} handleClose={handleClickClose} component={ModalAyuda} maxWidth="sm" />
      <div className={clsx({"header-gradient": props.isFromInicio}, { "header-hidden": !props.isFromInicio && isInicio}, { "header-common": !isInicio})}>
        <Container maxWidth="lg" >
          <Box sx={{ display: 'grid' }}>
            <Grid container className="header">
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Grid container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center">
                  {props.isFromInicio ?
                    <Link
                      underline='none'
                      href='https://inter.mx'
                    >
                      <img src={logo} alt='' />
                    </Link>
                    :
                    <Link
                      underline='none'
                      href='https://inter.mx'
                    >
                      <img src={logoAzul} alt='' />
                    </Link>
                  }
                </Grid>
              </Grid>
              {/* <Box component="button" sx={{ display: { xl: 'none', xs: 'block' } }} /> */}
              <Grid item xs={9} sm={9} md={9} lg={9} xl={9} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block' } }}>
                <Grid container
                  direction="row" justifyContent="flex-end" alignItems="center">
                  <Grid item xs={1} md={1}>
                  </Grid>
                  <Grid item xs={2} md={2} lg={2} xl={2}>
                    <Button
                      aria-controls='menu'
                      aria-haspopup='true'
                      onClick={handleOpenSeguros}
                    >
                      <span className='item-menu'>Seguros</span>
                    </Button>
                    <Menu
                      style={{ marginTop: '5' }}
                      id='menu'
                      onClose={handleCloseSeguros}
                      anchorEl={anchorEl2}
                      open={Boolean(anchorEl2)}
                    >
                      <MenuList>
                        <MenuItem>
                          <Link
                            color='Black'
                            underline='none'
                            href='https://cocheseguro.inter.mx/inicio'>
                            Coche Seguro
                          </Link>
                        </MenuItem>
                        <MenuItem>
                          <Link
                            color='Black'
                            underline='none'
                            href='https://mascotasegura.inter.mx/seguro-mascota/landing'>
                            Mascota Segura
                          </Link>
                        </MenuItem>
                        <MenuItem>
                          <Link
                            color='Black'
                            underline='none'
                            href='https://productos.inter.mx/vida-segura'>
                            Vida Segura
                          </Link>
                        </MenuItem>
                        <MenuItem>
                          <Link
                            color='Black'
                            underline='none'
                            href='https://productos.inter.mx/bien-seguro '>
                            Bien Seguro
                          </Link>
                        </MenuItem>
                        <MenuItem>
                          <Link
                            color='Black'
                            underline='none'
                            href='https://inter.mx/viaje-seguro'>
                            Viaja Seguro
                          </Link>
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Grid>
                  <Grid item xs={2} md={2}>
                    <Link
                      underline='none'
                      href='https://inter.mx/about-us'>
                      QUI&Eacute;NES SOMOS
                    </Link>

                  </Grid>
                  <Grid item xs={2} md={2}>
                    <Link
                      underline='none'
                      href='https://inter.mx/blog'>
                      BLOG
                    </Link>
                  </Grid>
                  <Grid item xs={2} md={2}>
                    <Link
                      underline='none'
                      href='https://inter.mx/promotions'>
                      PROMOCIONES
                    </Link>
                  </Grid>
                  <br />
                  <Grid item xs={2} md={2}>
                    <div className='promo'>
                      <ColorButton
                        variant="contained"
                        disableElevation
                        className="button-login promo"
                        onClick={handleClickModal}
                      >
                        <PhoneIcon />¿Necesitas ayuda?
                      </ColorButton>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={9} sm={9} md={9} lg={9} xl={9} sx={{ display: { xs: 'block', sm: 'block', md: 'block', lg: 'none', xl: 'none' } }}>
                <Grid container
                  direction="row" justifyContent="flex-end" alignItems="center">
                  <IconButton
                    className={clsx({ "text-color-white": props.isFromInicio && isInicio }, { "text-color-black": !props.isFromInicio && !isInicio })}
                    id="basic-button"
                    aria-controls="basic-menu"
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleMovil}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    <List
                      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                      component="nav"
                      aria-labelledby="nested-list-subheader"
                    >
                      <ListItemButton onClick={handleClick}>
                        <ListItemText primary="SEGUROS" />
                        {openL ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                      <Collapse in={openL} timeout="auto" unmountOnExit className='list-inicio'>
                        <List component="div" disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>

                            <ListItemText>
                              <Link
                                color='Black'
                                underline='none'
                                href='https://cocheseguro.inter.mx/inicio'>
                                <span className="textMovil">Coche Seguro</span>
                              </Link>
                            </ListItemText>
                            <ListItemText></ListItemText>
                          </ListItemButton>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemText>
                              <Link
                                color='Black'
                                underline='none'
                                href='https://mascotasegura.inter.mx/seguro-mascota/landing'>
                                <span className="textMovil">Mascota Segura</span>
                              </Link>
                            </ListItemText>
                            <ListItemText></ListItemText>
                          </ListItemButton>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemText>
                              <Link
                                color='Black'
                                underline='none'
                                href='https://productos.inter.mx/vida-segura'>
                                <span className="textMovil">Vida Segura</span>
                              </Link>
                            </ListItemText>
                            <ListItemText></ListItemText>
                          </ListItemButton>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemText>
                              <Link
                                color='Black'
                                underline='none'
                                href='https://productos.inter.mx/bien-seguro '>
                                <span className="textMovil">Bien Seguro</span>
                              </Link>
                            </ListItemText>
                            <ListItemText></ListItemText>
                          </ListItemButton>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemText>
                              <Link
                                color='Black'
                                underline='none'
                                href='https://inter.mx/viaje-seguro'>
                                <span className="textMovil">Viaja Seguro</span>
                              </Link>
                            </ListItemText>
                            <ListItemText></ListItemText>
                          </ListItemButton>
                        </List>
                      </Collapse>
                      <ListItemButton>
                        <ListItemText>
                          <Link
                            color='White'
                            underline='none'
                            href='https://inter.mx/about-us'>
                            <span className="textMovil">QUI&Eacute;NES SOMOS</span>
                          </Link>
                        </ListItemText>
                      </ListItemButton>
                      <ListItemButton>
                        <ListItemText>
                          <Link
                            color='White'
                            underline='none'
                            href='https://inter.mx/blog'>
                            <span className="textMovil">BLOG</span>
                          </Link>
                        </ListItemText>
                      </ListItemButton>
                      <ListItemButton>
                        <ListItemText>
                          <Link
                            color='White'
                            underline='none'
                            href='https://inter.mx/promotions'>
                            <span className="textMovil">PROMOCIONES</span>
                          </Link>
                        </ListItemText>
                      </ListItemButton>
                      <ListItemButton>
                        <ListItemText>
                          <div>
                            <Button sx={{ p: 0 }}
                              onClick={handleClickModal}
                            >
                              <span className='button-text-ayuda'>
                                <PhoneIcon />¿Necesitas ayuda?
                              </span>
                            </Button>
                          </div>
                        </ListItemText>
                      </ListItemButton>
                    </List>
                  </Menu>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </div>
    </>
  );
}
